module.exports = __webpack_public_path__ + "static/media/background-chatbot.cc32ff7d.png";